import Vue from "vue";
import Vuex from "vuex";
import service from "./services/product-service";

import auth from "@/store/modules/auth";
import roles from "@/store/modules/roles-module";
import productTiers from "@/store/modules/product-tiers-module";
import alerts from "./modules/alerts-module";
import permissions from "./modules/permissions-module";
import meta from "./modules/meta-module";
import users from "./modules/users-moduel";
import dashboard from "./modules/dashboard-module";
import arrivalDashboard from "./modules/arrival-dashboard-module";
import slaDashboard from "./modules/sla-dashboard-module";
import AIinsights from "./modules/ai-insights-module";
import geofence from "./modules/geofence-module";
import vehicles from "./modules/vehicles-module";
import customerVehicles from "./modules/customer-vehicles-module";
import vehicleTelematics from "./modules/vehicle-telematics-module";
import telematicDetails from "./modules/telematic-details-module";
import locations from "./modules/locations-module";
import iotDeviceMakes from "./modules/iot-device-makes-module";
import iotDeviceModels from "./modules/iot-device-models-module";
import iotDevices from "./modules/iot-devices-module";
import oemclients from "./modules/oem-clients-moduel";
import csoClients from "./modules/cso-clients-moduel";
import dataSims from "./modules/data-sims-module";
import mdMakes from "./modules/md-makes-module";
import vehicleTypes from "./modules/vehicle-types-module";
import batteryTypes from "./modules/battery-types-module";
import motorTypes from "./modules/motor-types-module";
import mdModels from "./modules/md-models-module";
import batteryMakes from "./modules/battery-makes-module";
import batteryModels from "./modules/battery-models-module";
import batterries from "./modules/batterries-module";
import drivingStaff from "./modules/driving-staff-module";
import staffAssignment from "./modules/staff-assignment-module";
import oemCustomers from "./modules/oem-customers-module";
import ticketManagement from "./modules/ticket-management-module";
import supportTickets from "./modules/support-tickets-module";
import flespiStream from "./modules/flespi-streams-module";
import flespiPlugin from "./modules/flespi-plugins-module";
import tableHeaders from "./modules/table-headers-module";
import vehicleChargeSession from "./modules/vehicle-charge-session-module";
import trips from "./modules/trips-module";
import vehicleTrips from "./modules/vehicle-trips-module";
import oemBusiness from "./modules/oemB2b-module";
import tenantsManagement from "./modules/tenants-management-module";
import tenantsConfigurations from "./modules/tenant-configurations-module";
import tenantsRelationship from "./modules/tenant-relationship-module";
import vehicleAssign from "./modules/vehicle-assign-module";
import products from "./modules/products-module";
import batteryDiagnostics from "./modules/battery-diagnostics-module";
import flespiCommands from "./modules/flespi-commands-module";
import comparison from "./modules/comparison-module ";
import flespiCalculator from "./modules/flespi-calculator-module";
import truckistanRoute from "./modules/truckistan-route-module";
import routes from "./modules/routes-module";
import routeListing from "./modules/route-listing-module";
import routePlaning from "./modules/route-planing-module";
import csmsLocations from "./modules/csms-locations-module";
import csmsRates from "./modules/csms-rates-module";
import terminal from "./modules/terminal-module";
import fuelTanks from "./modules/fuel-tank-module";
import fuelPrices from "./modules/fuel-prices-module";
import csmsChargingSession from "./modules/csms-charging-sessions-module";
import csmsChargingDiagnostics from "./modules/csms-charging-diagnostics-module";
import csmsOcppLogs from "./modules/csms-ocpp-logs-module";
import csmsChargeStations from "./modules/csms-charge-stations-module";
import csmsBookings from "./modules/csms-bookings-module";
import bookingOperator from "./modules/booking-operator-module";
import csmsDashboard from "./modules/csms-dashboard-module";
import fuelDashboard from "./modules/fuel-dashboard-module";
import dataLogs from "./modules/data-logs-module";
import fuelDispenserDashboard from "./modules/fuel-dispenser-dashboard-module";
import fuelDispenser from "./modules/dispenser-module";
import transitReports from "./modules/transit-reports-module";
import complianceReports from "./modules/compliance-reports-module";
import journeyReports from "./modules/journey-reports-module";
import dailyMileageReports from "./modules/daily-mileage-reports-module";
import maintenanceLogs from "./modules/maintenance-logs-module";
import upcomingMaintenance from "./modules/upcoming-maintenance-module";
import servicesLogs from "./modules/vehicle-services-logs-module";
import category from "./modules/category-module";
import parts from "./modules/parts-module";
import inventory from "./modules/inventory-module";
import generativeAI from "./modules/generative-ai-module";
import alertsAndNotify from "./modules/alerts-and-notification-module";
import notifications from "./modules/notification-module";
import order from "./modules/order-management-module";
import chargerMaintaince from "./modules/charger-maintaince-module";
import chargeStationsAssignment from "./modules/charge-stations-assignment-module";
import auditLogs from "./modules/audit-logs-module";
import energyAnalyzer from "./modules/energy-analyzer-module";
import firmware from "./modules/firmware-moduel";
import dataCompleteness from "./modules/data-completeness-module";
import utilizations from "./modules/utilizations-module";
import usersAnalyticsDashboard from "./modules/users-analytics-dashboard-module";
import revenueShare from "./modules/revenue-share-module";
import revenueSharing from "./modules/revenue-sharing-module";
import partnersAndDealers from "./modules/partners-and-dealers-module";
import tenantChargersAssignment from "./modules/tenant-chargers-assignment-module";
//
import redirect from "./modules/redirect-module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    roles,
    productTiers,
    alerts,
    permissions,
    meta,
    users,
    dashboard,
    arrivalDashboard,
    slaDashboard,
    AIinsights,
    geofence,
    vehicles,
    customerVehicles,
    vehicleTelematics,
    telematicDetails,
    locations,
    iotDeviceModels,
    oemclients,
    csoClients,
    dataSims,
    iotDeviceMakes,
    mdMakes,
    vehicleTypes,
    motorTypes,
    batteryTypes,
    mdModels,
    iotDevices,
    batteryMakes,
    batteryModels,
    batterries,
    drivingStaff,
    staffAssignment,
    oemCustomers,
    ticketManagement,
    supportTickets,
    flespiStream,
    flespiPlugin,
    tableHeaders,
    vehicleChargeSession,
    trips,
    vehicleTrips,
    oemBusiness,
    tenantsManagement,
    tenantsConfigurations,
    tenantsRelationship,
    vehicleAssign,
    products,
    batteryDiagnostics,
    flespiCommands,
    comparison,
    flespiCalculator,
    truckistanRoute,
    routes,
    routeListing,
    routePlaning,
    csmsLocations,
    csmsRates,
    csmsChargingSession,
    csmsChargingDiagnostics,
    csmsChargeStations,
    csmsBookings,
    bookingOperator,
    csmsDashboard,
    fuelDashboard,
    dataLogs,
    fuelDispenserDashboard,
    fuelDispenser,
    transitReports,
    complianceReports,
    journeyReports,
    dailyMileageReports,
    maintenanceLogs,
    upcomingMaintenance,
    servicesLogs,
    category,
    parts,
    inventory,
    generativeAI,
    alertsAndNotify,
    notifications,
    order,
    chargerMaintaince,
    csmsOcppLogs,
    terminal,
    fuelTanks,
    fuelPrices,
    chargeStationsAssignment,
    auditLogs,
    firmware,
    energyAnalyzer,
    dataCompleteness,
    utilizations,
    usersAnalyticsDashboard,
    revenueShare,
    revenueSharing,
    partnersAndDealers,
    tenantChargersAssignment,
    //
    redirect,
  },
  state: {
    barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
    barImage:
      "https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg",
    drawer: null,
    notifyDrawer: null,
    countries: [],
    states: [],
    cities: [],

    //
    codeList: ["+1", "+92"],
    tzList: ["America/Martinique", "Asia/Karachi"],
  },
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload;
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    SET_NOTIFY_DRAWER(state, payload) {
      state.notifyDrawer = payload;
    },

    //
    SET_COUNTRIES(state, payload) {
      state.countries = payload;
    },
    SET_STATES(state, payload) {
      state.states = payload;
    },
    SET_CITIES(state, payload) {
      state.cities = payload;
    },
  },
  actions: {
    setCountries: (store, params) => {
      return service.countries(params).then((data) => {
        store.commit("SET_COUNTRIES", data.countries);
      });
    },
    setStates: (store, params) => {
      return service.states(params).then((data) => {
        store.commit("SET_STATES", data.states);
      });
    },
    setCities: (store, params) => {
      return service.cities(params).then((data) => {
        store.commit("SET_CITIES", data.cities);
      });
    },
  },
  getters: {
    getTZList(state) {
      return state.tzList;
    },
    getCountryCode(state) {
      return state.codeList;
    },
    getCountries(state) {
      return state.countries;
    },
    getStates(state) {
      return state.states;
    },
    getCities(state) {
      return state.cities;
    },
  },
});
